

export const topPlayers = [
  {rank: 1, name: 'ShadowReaper', level: 215},
  {rank: 2, name: 'BlazingFury', level: 212},
  {rank: 3, name: 'NightPhantom', level: 210},
  {rank: 4, name: 'ArcaneMaster', level: 208},
  {rank: 5, name: 'SkyBreaker', level: 207},
  {rank: 6, name: 'IronVanguard', level: 206},
  {rank: 7, name: 'VenomStriker', level: 205},
  {rank: 8, name: 'FrostSpecter', level: 204},
  {rank: 9, name: 'ThunderClash', level: 203},
  {rank: 10, name: 'MysticKnight', level: 202},
];

export const topGuilds = [
  {rank: 1, name: 'LegendsUnited', points: 12000},
  {rank: 2, name: 'ShadowClan', points: 11500},
  {rank: 3, name: 'DragonSlayers', points: 11000},
  {rank: 4, name: 'NightRaiders', points: 10800},
  {rank: 5, name: 'PhoenixOrder', points: 10650},
  {rank: 6, name: 'StormBringers', points: 10400},
  {rank: 7, name: 'Frostborn', points: 10200},
  {rank: 8, name: 'TitanGuardians', points: 10050},
  {rank: 9, name: 'BlazingKnights', points: 9900},
  {rank: 10, name: 'CelestialWolves', points: 9700},
];

export const slides = [
  {
    img: '/assets/slider/slide1.webp',
    title: 'BATTLE ARENA',
    subtitle: 'FIGHT FOR GLORY',
    date: 'FRIDAY 20:00 CET',
    description: 'Enter the battle arena and prove yourself against the strongest warriors!',
  },
  {
    img: '/assets/slider/slide2.webp',
    title: 'GUILD WAR',
    subtitle: 'THE ULTIMATE CONQUEST',
    date: 'SATURDAY 18:00 CET',
    description: 'Gather your guild and conquer territories in the biggest war event!',
  },
  {
    img: '/assets/slider/slide3.webp',
    title: 'DOUBLE XP',
    subtitle: 'LEVEL UP FASTER',
    date: 'ALL WEEKEND',
    description: 'Earn double experience points and climb the ranks at lightning speed!',
  },
  {
    img: '/assets/slider/slide4.webp',
    title: 'RAID BOSS',
    subtitle: 'DEFEAT THE LEGENDARY FOE',
    date: 'SUNDAY 21:00 CET',
    description: 'Join forces and take down a powerful raid boss for epic rewards!',
  },
  {
    img: '/assets/slider/slide5.webp',
    title: 'TREASURE HUNT',
    subtitle: 'FIND THE HIDDEN GEMS',
    date: 'MONDAY 12:00 CET',
    description: 'Search for hidden treasures across the world and claim rare items!',
  },
  {
    img: '/assets/slider/slide6.webp',
    title: 'MYSTIC EVENT',
    subtitle: 'UNLOCK ANCIENT SECRETS',
    date: 'WEDNESDAY 15:00 CET',
    description: 'Discover mystical artifacts and unlock powerful abilities!',
  },
  {
    img: '/assets/slider/slide7.webp',
    title: 'DUNGEON CHALLENGE',
    subtitle: 'SURVIVE THE DEPTHS',
    date: 'THURSDAY 19:00 CET',
    description: 'Face new dungeon challenges and test your survival skills!',
  },
  {
    img: '/assets/slider/slide8.webp',
    title: 'PVP TOURNAMENT',
    subtitle: 'BECOME THE CHAMPION',
    date: 'SATURDAY 20:30 CET',
    description: 'Prove your skills in 1v1 battles and become the best warrior!',
  },
  {
    img: '/assets/slider/slide9.webp',
    title: 'EVENT BOSSES',
    subtitle: 'NEW MONSTERS APPEAR',
    date: 'FRIDAY 22:00 CET',
    description: 'Powerful event bosses have arrived! Defeat them for legendary loot!',
  },
  {
    img: '/assets/slider/slide10.webp',
    title: 'ELITE RAID',
    subtitle: 'ONLY THE STRONGEST SURVIVE',
    date: 'TUESDAY 17:00 CET',
    description: 'Gather your elite team and take on the hardest raid challenge yet!',
  },
  {
    img: '/assets/slider/slide11.webp',
    title: 'GUILD FESTIVAL',
    subtitle: 'EARN BONUS REWARDS',
    date: 'SUNDAY 14:00 CET',
    description: 'Complete guild quests and earn exclusive rewards!',
  },
  {
    img: '/assets/slider/slide12.webp',
    title: 'BLACKSMITH’S BLESSING',
    subtitle: 'INCREASED ENCHANT RATES',
    date: 'MONDAY 16:00 CET',
    description: 'Enhance your gear with increased success rates!',
  },
  {
    img: '/assets/slider/slide13.webp',
    title: 'MYSTERY BOXES',
    subtitle: 'SURPRISE REWARDS',
    date: 'TUESDAY 18:00 CET',
    description: 'Open mystery boxes for a chance to win rare and exclusive items!',
  },
  {
    img: '/assets/slider/slide14.webp',
    title: 'WORLD BOSSES',
    subtitle: 'A GLOBAL CHALLENGE',
    date: 'FRIDAY 21:00 CET',
    description: 'Fight alongside all players to take down global threats!',
  },
  {
    img: '/assets/slider/slide15.webp',
    title: 'HERO TRIALS',
    subtitle: 'TEST YOUR STRENGTH',
    date: 'THURSDAY 19:30 CET',
    description: 'Compete in trials and prove your heroism in tough battles!',
  },
  {
    img: '/assets/slider/slide16.webp',
    title: 'GOLDEN WEEKEND',
    subtitle: 'EXTRA GOLD DROPS',
    date: 'ALL WEEKEND',
    description: 'Earn extra gold from monsters and boost your wealth!',
  },
  {
    img: '/assets/slider/slide17.webp',
    title: 'PET EVOLUTION',
    subtitle: 'RARE PET UPGRADES',
    date: 'SATURDAY 18:00 CET',
    description: 'Special event to evolve pets with boosted success rates!',
  },
  {
    img: '/assets/slider/slide18.webp',
    title: 'SPECIAL SHOP',
    subtitle: 'LIMITED TIME OFFERS',
    date: 'MONDAY 10:00 CET',
    description: 'Exclusive items available in the shop for a short time!',
  },
  {
    img: '/assets/slider/slide19.webp',
    title: 'FESTIVAL OF LIGHTS',
    subtitle: 'CELEBRATE WITH FIREWORKS',
    date: 'WEDNESDAY 19:00 CET',
    description: 'Enjoy beautiful fireworks and receive special festival rewards!',
  },
  {
    img: '/assets/slider/slide20.webp',
    title: 'COSTUME EVENT',
    subtitle: 'GET UNIQUE OUTFITS',
    date: 'FRIDAY 12:00 CET',
    description: 'Limited edition costumes available for a short time!',
  },
  {
    img: '/assets/slider/slide21.webp',
    title: 'HEROIC QUESTS',
    subtitle: 'NEW STORY MISSIONS',
    date: 'TUESDAY 14:00 CET',
    description: 'Embark on new heroic quests and uncover hidden lore!',
  },
  {
    img: '/assets/slider/slide22.webp',
    title: 'LEGENDARY LOOT',
    subtitle: 'ENHANCED DROP CHANCES',
    date: 'THURSDAY 16:00 CET',
    description: 'Get better chances of finding ultra-rare loot!',
  },
  {
    img: '/assets/slider/slide23.webp',
    title: 'DARK INVASION',
    subtitle: 'FIGHT THE SHADOWS',
    date: 'SATURDAY 22:00 CET',
    description: 'Monsters from another realm are invading! Stop them before it’s too late!',
  },
  {
    img: '/assets/slider/slide24.webp',
    title: 'MOUNT RACE',
    subtitle: 'COMPETE FOR GLORY',
    date: 'SUNDAY 15:00 CET',
    description: 'Race your mounts against others and win amazing prizes!',
  },
  {
    img: '/assets/slider/slide25.webp',
    title: 'ALCHEMIST’S SECRET',
    subtitle: 'EXPERIMENT WITH POTIONS',
    date: 'WEDNESDAY 17:00 CET',
    description: 'Discover powerful potion recipes and craft rare elixirs!',
  },
  {
    img: '/assets/slider/slide26.webp',
    title: 'SIEGE WARFARE',
    subtitle: 'FIGHT FOR CASTLES',
    date: 'FRIDAY 20:00 CET',
    description: 'Participate in massive siege battles and take control of fortresses!',
  },
  {
    img: '/assets/slider/slide27.webp',
    title: 'HIDDEN DUNGEON',
    subtitle: 'DISCOVER THE UNKNOWN',
    date: 'TUESDAY 23:00 CET',
    description: 'A secret dungeon has appeared! Are you brave enough to explore it?',
  },
];
